const NAV_OFFSET_PX = 72;

export function scrollResultsIntoView(element) {
    if (!element) {
        return;
    }

    const top = element.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET_PX;
    window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
    });
}
